var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTabArrowToright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 15,
    viewBox: "0 0 71 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.7071 8.27852C71.0976 7.88799 71.0976 7.25483 70.7071 6.8643L64.3431 0.500343C63.9526 0.109819 63.3195 0.109819 62.9289 0.500343C62.5384 0.890868 62.5384 1.52403 62.9289 1.91456L68.5858 7.57141L62.9289 13.2283C62.5384 13.6188 62.5384 14.252 62.9289 14.6425C63.3195 15.033 63.9526 15.033 64.3431 14.6425L70.7071 8.27852ZM0 8.57141H70V6.57141H0V8.57141Z",
    fill: "#737DA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTabArrowToright);
export default __webpack_public_path__ + "static/media/icon-tab-arrow-toright.5b05204c80d8d8c32a474265095aa577.svg";
export { ForwardRef as ReactComponent };